import { render } from "./HistoryHome.vue?vue&type=template&id=2b1ae4f8&scoped=true"
import script from "./HistoryHome.vue?vue&type=script&lang=js"
export * from "./HistoryHome.vue?vue&type=script&lang=js"

import "./HistoryHome.vue?vue&type=style&index=0&id=2b1ae4f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1ae4f8"]])

export default __exports__